import { render, staticRenderFns } from "./chatmessage.vue?vue&type=template&id=1fb57a85&scoped=true&"
import script from "./chatmessage.vue?vue&type=script&lang=js&"
export * from "./chatmessage.vue?vue&type=script&lang=js&"
import style0 from "./chatmessage.vue?vue&type=style&index=0&id=1fb57a85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb57a85",
  null
  
)

export default component.exports